import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" class=\"design-iconfont\" id=\"icon-check\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#00B46D\" d=\"M32 0A32 32 0 1 0 32 64A32 32 0 1 0 32 0Z\" />\n    <path stroke=\"#FFF\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M19.869075 32L29.6277976 42.130925 46.087946 25.0429786\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol